import { createSelector } from 'reselect';
import { adobePassSelector, ipSelector } from 'selectors/authenticationSelectors';
import { isEmpty } from 'lib/util';

export default createSelector(
    adobePassSelector,
    ipSelector,
    (adobePassInfo, ipInfo) => {
        if (!isEmpty(adobePassInfo)) {
            return adobePassInfo;
        } else if (!isEmpty(ipInfo)) {
            return ipInfo;
        }
        return {};
    }
);



// WEBPACK FOOTER //
// ./app/selectors/providerSelector.js